export const SESSION_TIMEOUT_CONFIG = {
  NOTIFICATION_ID: 'session-timeout-notification',

  DEFAULT_TIMEOUT_MINUTES: 60,
  DEFAULT_WARNING_MINUTES: 55,

  MONITORED_EVENTS: ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click', 'focus', 'blur'] as const,

  THROTTLE_MS: 1000,
} as const;
